import React, { useState, useContext } from 'react';
import { Label, FieldControl, Input, Alert } from '@americanexpress/dls-react';
import { Address } from '../Address';
import { Industry } from '../Industry';
import { Email } from '../Email';
import userContext from '../../components/ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';

function CompanyDetail() {
    const [companyNameLengthError, setcompanyNameLengthError] = useState(false);
    const [companyNamePatternError, setcompanyNamePatternError] = useState(false);
    const { formData, setFormData } = useContext(userContext);
    const { errorData, setErrorData } = useContext(userContext);
    //const pattern = /^[0-9a-zA-Z \s\-.&']*$/;
    const onCompanyNameChange = (event) => {
        setFormData({ ...formData, companyName: event.target.value });

        if (event.target.value.length === 1) {
            setcompanyNameLengthError(true);
        }
        else if (event.target.value.length === 0) {
            setErrorData({ ...errorData, companyNameRequired: true });
        }
        else if (event.target.value !== '' && event.target.value.length >= 2) {
            const result = !CONSTANTS.validation.companyPattern.test(event.target.value);
            setcompanyNamePatternError(result);
            setcompanyNameLengthError(false);
            setErrorData({ ...errorData, companyNameRequired: false });
        }
        else {
            setcompanyNameLengthError(false);
            setErrorData({ ...errorData, companyNameRequired: false });
        }
    };

    return (
        <>
            <div className="col-md-6">
                <FieldControl>
                    <Label id="CompanyName-label" htmlFor="input-3" className="label-1">Company Name</Label>                   
                    <Input
                        id="CompanyName"
                        required={true}
                        value={formData.companyName}
                        onBlur={onCompanyNameChange}
                        maxLength={24}
                        onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                    />
                </FieldControl>
                <Alert id="CompanyName-alert" show={errorData.companyNameRequired}>Please Enter Company Name</Alert>
                <Alert id="companyNameLength-alert" show={companyNameLengthError}>The field must be a string with a minimum length of 2 and a maximum length of 24.</Alert>
                <Alert id="companyNamePattern-alert" show={companyNamePatternError}>Please ensure company name contains  only letters (A-Z, upper and lower case),digits(0-9), full stop, ampersand, spaces, hyphens and apostrophes.</Alert>
            </div>
            <div className="col-md-6">
                <Industry />
            </div>
            <div className="col-md-12">
                <Address type={CONSTANTS.addressType.office} descr="Company" label="Company Address" required="true" />
            </div>
            <div className="col-md-6 margin-0-b">
                {(formData.employmentStatus === "SALARIED_GOVERNMENT_SECTOR" || formData.employmentStatus === "SALARIED_PRIVATE_SECTOR" || formData.employmentStatus === "PROFESSIONAL" || formData.employmentStatus === "SELF_EMPLOYED_OR_FUNDED") &&
                  <Email type="CompanyEmail" title="Company Email Address" />                                       
                }
            </div>
            <div className="col-md-12">
                {(formData.employmentStatus.toLowerCase() === CONSTANTS.employmentStatus.salariedPublicSector.toLowerCase() || formData.employmentStatus.toLowerCase() === CONSTANTS.employmentStatus.salariedPvtSector.toLowerCase() || formData.employmentStatus.toLowerCase() === CONSTANTS.employmentStatus.professional.toLowerCase() || formData.employmentStatus.toLowerCase() === CONSTANTS.employmentStatus.selfEmployed.toLowerCase()) &&
                <p>We may send a one-time email to your company email address. Alternatively, you can enter your personal email ID, however, we may need additional documentation </p>
            }
                </div>
        </>
    );
}
export default CompanyDetail;